import Syntax from './Syntax';

export default Syntax;
